import dateRange from './date-range'
import editableTrendTag from './editable-trend-tag'
import image from './image'
import macrotrendAutocomplete from './macrotrend-autocomplete'
import megatrendSelect from './megatrend-select'
import password from './password'
import uploadButton from './upload-button'
import userSelect from './user-select'
import titleDescription from './title-description'

export default {
    dateRange,
    editableTrendTag,
    image,
    macrotrendAutocomplete,
    megatrendSelect,
    password,
    titleDescription,
    uploadButton,
    userSelect
}
